import React from 'react'
import reactHOC from 'react-hoc'
import { getDeviceInfo } from 'helpers/useragent'

const WithDeviceHOC = reactHOC(WrappedComponent => props => (
  <WrappedComponent device={getDeviceInfo()} {...props} />
), 'WithDevice')

export default WithDeviceHOC
